<div class="container">
  <app-filters
    [headerFilters]="headerFilters"
    (applyFilters)="applyFilters($event)"
  >
  </app-filters>

  <mat-tab-group>
    <mat-tab label="Registro de Logs">
      <div class="w-100 mt-4">
        <data-table
          [title]="titleLog"
          [columns]="columnsLog"
          [configuration]="configurationLog"
          [reloadTable]="reloadTableLog"
          [params]="params"
          [url]="EndpointDictionary.Logs.LOGS_TABLE"
          (delete)="deleteClickRow($event)"
        ></data-table>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
